import {
    VENDOR_COM_LOGO_REQUEST,
    VENDOR_COM_LOGO_SUCCESS,
    VENDOR_COM_LOGO_FAIL
  } from "../constants/AuthConstant";
  
  const initialState = {
    loading: false,
    action: "Profile Action",
    result: [],
    msg: "",
    error: "",
  };
  
  const VendorUpdateComLogoReducer = (state = initialState, action) => {
    switch (action.type) {
      case VENDOR_COM_LOGO_REQUEST:
        return {
          ...state,
          loading: action.payload,
        };
      case VENDOR_COM_LOGO_SUCCESS:
        return {
          ...state,
          result: action.result.data,
          loading: action.payload,
          msg: action.msg,
        };
      case VENDOR_COM_LOGO_FAIL:
        return {
          ...state,
          error: action.error,
          loading: action.payload,
          msg: action.msg,
        };
  
      default:
        return state;
    }
  };
  
  export default VendorUpdateComLogoReducer;
  